import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { useQuoteRequestLine } from "#modules/quoteRequestLines/view/useQuoteRequestLine";
import { ClusterCard } from "#modules/similarPart/view/clustering/ClusterCard";

type Props = {
  quoteRequestLineId: string;
  isSelected: boolean;
  handleToggleSelect: () => void;
  sourcePart: PartDto;
  index: number;
};

export const SimilarPartCard = ({
  quoteRequestLineId,
  sourcePart,
  isSelected,
  handleToggleSelect,
  index,
}: Props) => {
  const { quoteRequestLine } = useQuoteRequestLine({ id: quoteRequestLineId });

  if (!quoteRequestLine) {
    return null;
  }

  return (
    <ClusterCard
      key={quoteRequestLine.partId}
      index={index}
      isSelected={isSelected}
      handleToggleSelect={handleToggleSelect}
      sourcePart={sourcePart}
      targetPart={{
        ...quoteRequestLine,
        cluster: null,
        productLines: [],
        layout: null,
        processSteps: quoteRequestLine.processSteps.map((ps) => ({
          ...ps,
          productLines: [],
        })),
      }}
    />
  );
};
